import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axios from 'axios';

import Styled from './styles';
import { useGlobalModalContext } from '../..';
import { useUtils } from '../../../../core/hooks/useUtils';
import { IStore } from '../../../../store/rootReducer';
import InviteItem from '../../../invite-item';
import AppButton from '../../../app-button';
import { Typography } from '../../../typography';
import TeamMember from '../../../team-member';
import colors from "../../../../assets/colors";
import CloseIcon from "@material-ui/icons/Close";

interface HookState {
	allMembers: any[];
	isCopied: boolean;
}

export const InviteModal = () => {
	const { hideModal, store } = useGlobalModalContext();
	const { modalProps } = store || {};
	const utils = useUtils();

	const { title, field, isMembers, inviteMember, approveMember } =
		modalProps || {};
	const users = utils.store[field as keyof IStore];
	const { data } = users as { data: any[] };

	const [state, setState] = useState<HookState>({
		allMembers: [],
		isCopied: false,
	});

	useEffect(() => {
		setState(prev => ({ ...prev, allMembers: data }));
	}, [data]);

	const selectUser = (_id: string): void => {
		inviteMember(_id);
		setState(prev => ({
			...prev,
			allMembers: prev.allMembers.map(member => {
				if (member._id === _id) {
					return { ...member, isParticipated: !member.isParticipated };
				}
				return member;
			}),
		}));
	};

	const sendInvite = (item: any): void => {
		const { id, email } = item;
		inviteMember(email);
		setState(prev => ({
			...prev,
			allMembers: prev.allMembers.map(member => {
				if (member.id === id) {
					return { ...member, status: 'Invited' };
				}
				return member;
			}),
		}));
	};

	const approveInvite = (item: any): void => {
		const { id, email } = item;
		approveMember(email);
		setState(prev => ({
			...prev,
			allMembers: prev.allMembers.map(member => {
				if (member.id === id) {
					return { ...member, status: 'Approved' };
				}
				return member;
			}),
		}));
	};

	const handleModalToggle = () => {
		hideModal();
	};

	const getInviteLink = () => {
		axios
			.get('/users/invite')
			.then(res => {
				navigator.clipboard.writeText(res.data.data);
			})
			.then(() => {
				setState(prevState => ({
					...prevState,
					isCopied: true,
				}));
			});
	};

	const { allMembers } = state;

	return (
		<Modal
			isOpen={true}
			className={'Invite'}
			onRequestClose={handleModalToggle}
			shouldCloseOnEsc
			shouldCloseOnOverlayClick
			style={{
				content: {
					overflow: 'none',
				},
			}}
		>
			<Styled.ModalContent>
				<div
					style={{
						marginBottom: 50,
						marginTop: 30,
						display: 'flex',
						justifyContent: 'space-between',
					}}
				>
					<Styled.Title text={title} type="bold" />
					<Styled.Close onClick={handleModalToggle}>
						<CloseIcon style={{ color: colors.black }} />
					</Styled.Close>
				</div>
				<Styled.TeamMembers>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div style={{ flex: 1, textAlign: 'center' }}>
							<Typography text="Team" color="btnTextGrey" />
						</div>
						<div style={{ flex: 1, textAlign: 'center' }}>
							<Typography text="Status" color="btnTextGrey" />
						</div>
						<div style={{ flex: 1, textAlign: 'center' }}>
							<Typography text="Action" color="btnTextGrey" />
						</div>
					</div>
					<div
						style={{
							overflow: 'auto',
							padding: '20px 0',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'flex-end',
						}}
					>
						{allMembers.map((item: any, i) =>
							isMembers ? (
								<TeamMember
									key={i}
									item={item}
									sendInvite={sendInvite}
									approveInvite={approveInvite}
									isMembers={isMembers}
								/>
							) : (
								<InviteItem
									key={i}
									item={item}
									selectUser={selectUser}
									isMembers={isMembers}
								/>
							)
						)}
					</div>
				</Styled.TeamMembers>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						paddingTop: 30,
						paddingBottom: 30,
					}}
				>
					<AppButton
						style={{ width: 180, height: 45 }}
						title={state.isCopied ? 'Copied' : '+ Invite others to Revvy'}
						color="white"
						titleColor="black"
						hoverText="black"
						hover="black"
						borderWidth={1}
						borderColor="black"
						type="bold"
						callBack={getInviteLink}
					/>
				</div>
			</Styled.ModalContent>
		</Modal>
	);
};
